module.exports = __webpack_public_path__ + "img/Checked-white.bddcca84.svg";